<template>
  <div class="navbar navbar-default navbar-static-top py-0">
    <div class="container d-flex">
      <div class="navbar-header" v-if="isTutor === false">
        <a href="/dashboard/assessments" class="navbar-brand">GSPT Assess</a>
      </div>
      <div class="navbar-header" v-else>
        <a href="javascript:;" class="navbar-brand">GSPT Assess</a>
      </div>
      <ul class="mr-auto navbar-nav" style="flex-direction: row" v-if="isTutor === false">
        <a href="/dashboard/assessments" class="nav-item nav-link px-2">Assessments</a>
        <a href="/dashboard/create-assessment" class="nav-item nav-link px-2">Create Assessment</a>
        <a href="/dashboard/templates" class="nav-item nav-link px-2">Templates</a>
      </ul>

      <ul class="ml-auto navbar-nav" v-if="isTutor === false">
        <router-link to="/" class="nav-item nav-link px-2" v-if="isLoggedIn === false">Login</router-link>
        <a @click="logout()" href="javascript:;" class="nav-item nav-link px-2" v-else>Logout</a>
      </ul>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { removeCookies } from "@/util";

export default {
  data() {
    return {
      isLoggedIn: false
    };
  },
  methods: {
    logout() {
      removeCookies();
      this.$router.push("/");
      this.isLoggedIn = false;
    }
  },
  computed: {
    isTutor() {
      return this.$route.path.includes("/tutor/");
    }
  },
  created() {
    this.$root.$on("login", () => (this.isLoggedIn = true));
    this.isLoggedIn = !!Cookies.get("token");
  }
};
</script>


<style lang="scss" scoped>
.navbar.navbar-default {
  background: #3d484e;
}

.navbar.navbar-default * {
  color: #fff !important;
}

.navbar-default .navbar-nav .nav-item {
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 14px;
}

.navbar-default .navbar-nav > .router-link-active {
  background-color: transparent !important;
  box-shadow: inset 0 -4px 0 0 #fff;
  cursor: default;
}

.navbar-brand {
  font-weight: 600;
}
</style>